import http from '@/utils/request';

// 创建PPT
export function _createPPT(data: any) {
  return http({
    url: `/api/v2/aippt`,
    method: 'post',
    data,
    httpType: 'pptApi'
  } as any);
}

// PPT列表
export function _getPPTList(params: any) {
  return http({
    url: `/api/v2/aippt/list`,
    method: 'get',
    params,
    httpType: 'pptApi'
  } as any);
}

// 回收站列表
export function _getTrashList(params: any) {
  return http({
    url: `/api/v2/aippt/trash/list`,
    method: 'get',
    params,
    httpType: 'pptApi'
  } as any);
}

// 移入回收站
export function _putTrashById(id: any) {
  return http({
    url: `/api/v2/aippt/trash/${id}`,
    method: 'put',
    httpType: 'pptApi'
  } as any);
}
// 移出回收站
export function _putRecoverById(id: any) {
  return http({
    url: `/api/v2/aippt/recover/${id}`,
    method: 'put',
    httpType: 'pptApi'
  } as any);
}

// PPT详情
export function _getPPTDetail(id: any) {
  return http({
    url: `/api/v2/aippt/${id}`,
    method: 'get',
    httpType: 'pptApi'
  } as any);
}

// 保存
export function _postSavePPT(id: any, data: any) {
  return http({
    url: `/api/v2/aippt/${id}`,
    method: 'post',
    data,
    httpType: 'pptApi'
  } as any);
}

// 删除
export function _deletePPT(id: any) {
  return http({
    url: `/api/v2/aippt/${id}`,
    method: 'delete',
    httpType: 'pptApi'
  } as any);
}
